import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";

/**
 * COMPONENTE FOTO (reutilizável)
 * --------------------------------
 * Props:
 *  show: boolean
 *  onClose: function
 *  foto: string (url/base64)
 *  nome: string (GRANDE)
 *  info01: string (MÉDIO)
 *  info02: string (MENOR)
 */

export default function Foto({
  show,
  onClose,
  foto,
  nome,
  info01,
  info02,
}) {
  const [fullscreen, setFullscreen] = useState(false);

  // FULLSCREEN VIA PORTAL
  const fullscreenView = (
    <AnimatePresence>
      {fullscreen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="foto-fullscreen"
          onClick={() => setFullscreen(false)}
        >
          <motion.img
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.9 }}
            src={foto}
            alt="Foto ampliada"
            className="foto-fullscreen-img"
          />

          <div className="foto-fullscreen-nome">{nome}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <>
      {/* MODAL PRINCIPAL */}
      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        dialogClassName="foto-modal-dialog"
        contentClassName="bg-dark text-white border-0 shadow-lg"
      >
        <Modal.Header closeButton closeVariant="white" className="border-0 pb-0" />

        <Modal.Body className="p-0 d-flex flex-column align-items-center justify-content-center">
          <div className="w-100 d-flex justify-content-center align-items-center foto-img-wrapper">
            {foto && (
              <img
                src={foto}
                alt="Foto"
                onClick={() => setFullscreen(true)}
                className="foto-img"
              />
            )}
          </div>

          <div className="w-100 text-center px-3 pb-3 mt-2">
            <div className="foto-nome">{nome}</div>
            {info01 && <div className="foto-info1">{info01}</div>}
            {info02 && <div className="foto-info2">{info02}</div>}
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center pb-4 pt-1">
          <Button variant="outline-light" className="btn-fechar-foto px-4" onClick={onClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PORTAL GARANTE TELA INTEIRA REAL */}
      {typeof document !== "undefined" &&
        createPortal(fullscreenView, document.body)}

      {/* ESTILOS DE COR PADRONIZADOS */}
      <style jsx>{`
        /* ===== TAMANHO FIXO DO MODAL ===== */
        :global(.foto-modal-dialog) {
          max-width: 720px;
        }

        :global(.foto-modal-dialog .modal-content) {
          border-radius: 20px;
          background-color: #121824 !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
        }

        /* Mobile = tela cheia */
        @media (max-width: 768px) {
          :global(.foto-modal-dialog) {
            max-width: 100vw;
            margin: 0;
            height: 100vh;
          }

          :global(.foto-modal-dialog .modal-content) {
            height: 100vh;
            border-radius: 0;
          }
        }

        /* ===== IMAGEM ===== */
        .foto-img-wrapper {
          height: clamp(260px, 55vh, 420px);
          padding: 10px;
        }

        .foto-img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          cursor: zoom-in;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
          transition: transform 0.2s ease;
        }

        .foto-img:hover {
          transform: scale(1.01);
        }

        /* ===== TEXTOS ===== */
        .foto-nome {
          font-size: clamp(1.4rem, 2.5vw, 1.8rem);
          font-weight: 800;
          margin-top: 8px;
          color: #ffffff;
          letter-spacing: -0.5px;
        }

        .foto-info1 {
          font-size: clamp(1rem, 2.2vw, 1.2rem);
          color: #b31d1d;
          font-weight: 700;
          margin-top: 2px;
        }

        .foto-info2 {
          font-size: clamp(0.85rem, 2vw, 0.95rem);
          color: #94a3b8;
          font-weight: 500;
          margin-top: 2px;
        }

        /* ===== BOTÃO FECHAR ===== */
        :global(.btn-fechar-foto) {
          border-radius: 12px !important;
          font-weight: 600 !important;
          border-color: rgba(255, 255, 255, 0.2) !important;
          transition: all 0.2s ease !important;
        }

        :global(.btn-fechar-foto:hover) {
          background-color: #b31d1d !important;
          border-color: #b31d1d !important;
          color: #ffffff !important;
        }

        /* ===== FULLSCREEN ===== */
        .foto-fullscreen {
          position: fixed;
          inset: 0;
          background: rgba(10, 15, 26, 0.98);
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 20px;
          cursor: zoom-out;
        }

        .foto-fullscreen-img {
          max-width: 100%;
          max-height: 85vh;
          object-fit: contain;
          border-radius: 8px;
        }

        .foto-fullscreen-nome {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background: linear-gradient(180deg, transparent 0%, rgba(139, 0, 0, 0.95) 100%);
          color: #fff;
          text-align: center;
          padding: 20px 10px 16px 10px;
          font-weight: 700;
          font-size: 1.25rem;
        }
      `}</style>
    </>
  );
}